<template>
  <div
    id="app"
    :class="{ nomobile: !isMobile }"
    @dblclick="toggleBodyClass"
    :style="swayStyle"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      loading: false,
      tokenTimer: null,
      sawyTimer: null,
      swayStyle: {},
      isMobile: false,
    };
  },
  components: {},
  watch: {
    $route: {
      handler(newVal) {
        this.handleCountdown();
        this.initSway();
        this.noticeShow = false;
        if (newVal.meta && newVal.meta.type) {
          let type = newVal.meta.type;
          if (type == "livePage") {
            this.noticeShow = true;
          }
        }
      },
      deep: true,
    },
  },

  created() {
    // console.log("APP create");
  },
  mounted() {
    console.log("APP mounted");
    
    let token = localStorage.getItem("token") || '';
    if (!token) {
      token = this.$common.getCookie("juima_access_token") || "";
      if (token) {
        localStorage.setItem("token", token);
        this.refreshToken();
      }
    }
    this.getIsMoile();
   
  },
  methods: {
    getIsMoile() {
      let routeInfo = this.$route.matched[0];
      if (routeInfo) {
        let name = routeInfo.name;
        if (name == "console") return;
        let deviceType = this.$common.detectDeviceType();
        if (deviceType == "mobile") {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      }
    },
    handleCountdown() {
      let that = this;
      clearInterval(that.tokenTimer);
      that.tokenExpired();
      that.tokenTimer = setInterval(() => {
        that.tokenExpired();
      }, 5000);
    },

    normalizeExpires(value) {
      const expires = Number(value) || 0;
      if (!expires) return 0;
      return expires < 10000000000 ? expires * 1000 : expires;
    },

    tokenExpired() {
      const token = localStorage.getItem("token");
      const auth = this.$route.meta.auth;
      if (!token) return;
      let expires = localStorage.getItem("expires") || 0;
      const normalizedExpires = this.normalizeExpires(expires);
      if (!normalizedExpires) return;
      const expiresIn = normalizedExpires - Date.now();
      const outTime = 30 * 60 * 1000;
      // console.log(expiresIn, outTime, token);
      if (expiresIn > 0) {
        if (token && expiresIn < outTime) {
          if (auth) {
            this.refreshToken();
          }
        }
      } else {
        clearInterval(this.tokenTimer);
        if (auth) {
          //  window.location.href = process.env.VUE_APP_WEB_URL;
          this.$router.go(0);
        }
      }
    },
    async refreshToken() {
      const tokenAtRequest = localStorage.getItem("token");
      if (!tokenAtRequest) return;
      let {
        data: { data, code },
      } = await this.$http.post("/user/refreshToken");
      if (localStorage.getItem("token") !== tokenAtRequest) return;
      if (code == 200) {
        const newToken = data.access_token;
        let expires = data.access_token_exp;
        let username = data.user_info.username;
        let is_test = data.user_info.is_test;
        localStorage.setItem("username", username);
        localStorage.setItem("is_test", is_test);
        localStorage.setItem("token", newToken);
        localStorage.setItem("expires", expires);
      } else if (code == 401) {
        // window.location.href = process.env.VUE_APP_WEB_URL;
        this.$router.go(0);
      }
    },
    async checkAndUpdateCookie() {
      let account = this.$common.getCookie("account");
      let password = this.$common.getCookie("password");
      let {
        data: { data, code },
      } = await this.$http.post("/user/login", {
        account: account,
        password: password,
      });
      if (code == 200) {
        const newToken = data.access_toke;
        this.$common.setToken(newToken);
      } else {
        this.checkAndUpdateCookie();
      }
    },
    getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    getExpiresIn(token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const expiresAt = payload.exp * 1000;
      return expiresAt - Date.now();
    },
    toggleBodyClass() {
      let routeInfo = this.$route.matched[0];
      if (routeInfo) {
        let name = routeInfo.name;
        if (name == "console") return;
        this.noticeShow = true;
        const body = document.body;
        const className = "overflow";
        if (body.classList.contains(className)) {
          body.classList.remove(className);
        } else {
          body.classList.add(className);
        }
      }
    },
    initSway() {
      let routeInfo = this.$route.matched[0];
      if (routeInfo) {
        let name = routeInfo.meta.tab || "";
        if (!name) return;
        let that = this;
        let initTimer = setTimeout(() => {
          that.swayCountdown();
          clearTimeout(initTimer);
        }, 600000);
      }
    },
    swayCountdown() {
      let sawyNum1 = Math.floor(Math.random() * 21) + 10;
      let sawyNum2 = Math.floor(Math.random() * 4) + 3;
      let swayTimer = sawyNum1 * 60000;
      let swayOut = sawyNum2 * 1000;
      const body = document.body;
      const className = "overflow";
      let self = false;
      if (body.classList.contains(className)) {
        self = true;
      } else {
        self = false;
        body.classList.add(className);
      }
      let that = this;
      let intervalTimer = setInterval(() => {
        that.changeAnimation();
      }, 200);
      let timeoutTimer = setTimeout(() => {
        that.swayStyle = {};
        if (self) {
          body.classList.add(className);
        } else {
          body.classList.remove(className);
        }
        clearInterval(intervalTimer);
        clearInterval(timeoutTimer);
      }, swayOut);
      if (that.sawyTimer) {
        clearInterval(that.sawyTimer);
      }
      that.sawyTimer = setTimeout(() => {
        that.swayCountdown();
      }, swayTimer);
    },
    changeAnimation() {
      let w = this.getRandomNumber(-1, 1);
      let h = this.getRandomNumber(-1, 1);
      let obj = {
        marginLeft: w,
        marginTop: h,
      };
      this.swayStyle = obj;
    },
    getRandomNumber(min, max) {
      let randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      let sway = randomNum + "px";
      return sway;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.css";
html,
body {
  min-height: 100vh;
  width: 100%;
  // min-width: 1080px;
  margin: 0;
  padding: 0;
  user-select: none;
  -webkit-font-smoothing: antialiased; /* Chrome, Safari */
  -moz-osx-font-smoothing: grayscale; /* Firefox */
  text-rendering: optimizeLegibility; /* General */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  margin: 0;
  min-height: 100vh;
  width: 100%;
  transition: all 0.2s linear;
}
.notice-btn {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 99999;
}
.nomobile {
  .container {
    height: 100vh !important;
    overflow: hidden !important;
  }
}
</style>
